const windowShim = typeof window !== 'undefined' ? window : undefined;
const documentShim = typeof document !== 'undefined' ? document : undefined;
const navigatorShim = typeof navigator !== 'undefined' ? navigator : undefined;

export {
  windowShim as window,
  documentShim as document,
  navigatorShim as navigator,
};
